import { AccessControlSite, AccessControlDevice } from '../../../views/AccessControl'

export const getAccessControlDevicesByLot = (
    sites: AccessControlSite[],
    devices: AccessControlDevice[],
    lotId: string | undefined
): AccessControlDevice[] => {
    if (!lotId) {
        return []
    }

    // Find the site that matches this lot ID
    const matchingSite = sites.find((site) => site.pd_lot_id === lotId)

    if (!matchingSite || !matchingSite.site) {
        return []
    }

    // Return all devices that belong to this site
    return devices.filter((device) => device.site === matchingSite.site)
}
